import Section from './Section.js';

export default Section;
